<template>
	<div id="app">
		<router-view :key="$route.fullPath" />
	</div>
</template>

<script>
	export default {
		name: 'App',
		components: {},
		created() {
			if(!sessionStorage.getItem('token')){
				this.$router.push('/login')
			}
			
			document.title='消安天天查数据监管系统'
			sessionStorage.setItem('provinceCode', '');
			sessionStorage.setItem('cityCode', '');
			sessionStorage.setItem('districtCode', '');
			sessionStorage.setItem('townshipCode', '');
			sessionStorage.setItem('startDate', '');
			sessionStorage.setItem('endDate', '');
		}
	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		padding: 0;
		margin: 0;
	}
</style>